// extracted by mini-css-extract-plugin
module.exports = {"contactsWrapper":"style_contactsWrapper__2Md66","infoBlock":"style_infoBlock__31IFP","map":"style_map__IvYHT"};